export enum SubscriptionType {
    Basic = 'BASIC',
    Premium = 'PREMIUM',
    None = 'NONE'
}